import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=22791a1b&scoped=true&lang=pug"
import script from "./page-header.vue?vue&type=script&lang=ts"
export * from "./page-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22791a1b",
  null
  
)

export default component.exports